import { useUserContext } from "./useUserContext";
import { checkFeatureFlag } from "@/app/_config/featureFlags";

/**
 * Hook to check if a feature flag is enabled for the current user
 */
export default function useFeatureFlag(
  flagName: "MM_PAYMENTS_ONBOARDING" | "MM_PAYMENTS_ENABLED"
): boolean {
  const user = useUserContext();

  // Use the user's uid to check against allowedUserIds if applicable
  return checkFeatureFlag(flagName, user?.uid);
}
